import intellegenceService from './../shared/services/intellegenceService'
import getDates from './../shared/services/date.service'
import { setLogout } from './authActions'

const REQUEST_SENSORS = 'REQUEST_SENSORS'
const RESPONSE_SENSORS = 'RESPONSE_SENSORS'
const REQUEST_SENSORS_FAILURE = 'REQUEST_SENSORS_FAILURE'
const CLEAR_SENSORS = 'CLEAR_SENSORS'
const SET_SENSORS_DATA_READY = 'SET_SENSORS_DATA_READY'
const SET_SENSORS_DATA_EMPTY = 'SET_SENSORS_DATA_EMPTY'

const requestSensorsAction = () => {
  return {
    type: REQUEST_SENSORS
  }
}

const responseSensorsAction = (data) => {
  return {
    type: RESPONSE_SENSORS,
    data
  }
}

const requestSensorsFailureAction = (errors) => {
  return {
    type: REQUEST_SENSORS_FAILURE,
    errors
  }
}

const getSensors = (id, date) => {
  return (dispatch) => {
    dispatch(requestSensorsAction())

    let options = {
      date: getDates.fixISOStringDateToPost(date)
    }

    intellegenceService.getSensorsData(id, options)
      .then((result) => {
        dispatch(responseSensorsAction(result.data))
      })
      .catch((error) => {
        dispatch(requestSensorsFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

const clearSensorsAction = () => {
  return {
    type: CLEAR_SENSORS
  }
}

const setSensorsDataReadyAction = () => {
  return {
    type: SET_SENSORS_DATA_READY
  }
}

const setSensorsDataReady = () => {
  return (dispatch) => {
    dispatch(setSensorsDataReadyAction())
  }
}

const setSensorsDataEmptyAction = () => {
  return {
    type: SET_SENSORS_DATA_EMPTY
  }
}

const setSensorsDataEmpty = () => {
  return (dispatch) => {
    dispatch(setSensorsDataEmptyAction())
  }
}

export {
  getSensors,
  requestSensorsAction,
  responseSensorsAction,
  requestSensorsFailureAction,
  clearSensorsAction,
  setSensorsDataEmpty,
  setSensorsDataEmptyAction,
  setSensorsDataReady,
  setSensorsDataReadyAction,
  REQUEST_SENSORS,
  RESPONSE_SENSORS,
  REQUEST_SENSORS_FAILURE,
  CLEAR_SENSORS,
  SET_SENSORS_DATA_READY,
  SET_SENSORS_DATA_EMPTY
}